import {safePropEq} from '@sinclair-digital/stl-common/src/sinclair/sinclair.utils';
import {Collection, Model} from 'backbone';
import {dissoc, pipe, propOr} from 'ramda';

// propOrSelf :: String -> {s: a} -> a | {s: a}
const propOrSelf = field => o => propOr(o, field)(o);

const UserModel = Model.extend({
    idAttribute: 'uuid',
    url: '/api/user',
    defaults: {
        username: '',
        email: '',
        firstName: '',
        lastName: '',
        properties: [],
        ldapGroups: [],
        distinguishedName: null,
        mfaRequired: false,
    },
    initialize() {
        this.set('properties', new Collection(this.get('properties')));
    },
    parse(serverData = {}) {
        const parsed = pipe(
            propOrSelf('data'),
            propOrSelf(0),
            dissoc('response'),
        )(serverData);
        parsed.properties = new Collection(parsed.properties);
        return parsed;
    },
    setProperties(properties) {
        this.get('properties').reset(properties);
    },
    addProperty(property) {
        this.get('properties').add({
            property,
            roles: [],
        });
    },
    getPropertyByUuid(uuid) {
        const global = !uuid;
        const getGlobal = property => !property.get('property');
        const getProperty = property => safePropEq('uuid', uuid)(property.get('property'));
        const findMethod = global ? getGlobal : getProperty;

        return this.get('properties').find(findMethod);
    },
    removeProperty(uuid) {
        this.get('properties').remove(this.getPropertyByUuid(uuid));
    },
    assignPropertyContextRole(propertyUuid, roleId) {
        const property = this.getPropertyByUuid(propertyUuid);
        property.set({roles: property.get('roles').concat({id: roleId})});
    },
    unassignPropertyContextRole(propertyUuid, roleId) {
        const property = this.getPropertyByUuid(propertyUuid);
        property.set({roles: property.get('roles').filter(r => r.id !== roleId)});
    },
});
export default UserModel;
